<template>
  <div>
    <div v-if="isAuctionStarted" :key="`auction-${outLotId}`" class="auction-process-div">
      <el-col :span="8">
        <table class="flowChartTable1">
          <tr style="display: flex;justify-content: flex-start;align-items: center;">
            <td>
              <el-tag :type="isApplyPassed ? 'success' : 'primary'"
                      style="width: 60px; height: 60px; border-radius: 50%; box-shadow: 1px 1px 5px #000; margin-top: 5px;">
                <div
                    style="font-size: 16px; text-align: center; display: flex; flex-direction: column; padding-top: 8px;">
                  <div>1</div>
                  <div style="font-size: 12px; margin-top: -10px;">报名</div>
                </div>
                <i class="el-icon-bottom" style="margin-left: 5%; font-size: 40px; margin-top: 5%;"></i>
              </el-tag>
            </td>
            <td style="display: flex; flex-direction: column; justify-content: center; align-items: flex-start; margin-left: -20px; margin-top: -40px; width: 100%;">
              <div style="display: flex; justify-content: center; align-items: center; margin-bottom: 5px;">
                <el-button
                    :disabled="applyState === 1 || applyState === 2 || applyState === 3 || !isApplyTimeValid"
                    :plain="!(applyFileState === 1 || applyFileState === 2)"
                    :type="applyStatusType"
                    icon="el-icon-circle-check"
                    size="mini"
                    style="width: 90px;justify-content: flex-start;padding-left: 8px;"
                    @click="toApply">
                  {{ applyStatusText }}
                </el-button>
                <el-button :disabled="!isApplyPassed" :type="isApplyPassed ? 'success' : 'info'"
                           icon="el-icon-circle-check"
                           plain size="mini" style="width: 110px;justify-content: flex-start;padding-left: 8px;" @click="downloadBiddingRules">
                  下载竞价规则
                </el-button>
              </div>
              <div v-if="applyState === 3"
                   style="display: flex; justify-content: flex-start; align-items: center; width: 100%; margin-top: 5px;">
                <el-button
                    icon="el-icon-circle-check"
                    plain
                    size="mini"
                    style="width: 90px;justify-content: flex-start;padding-left: 8px;"
                    type="primary"
                    @click="toApply">
                  重新报名
                </el-button>
                <el-button
                    icon="el-icon-circle-check"
                    plain
                    size="mini"
                    style="width: 110px; justify-content: flex-start;padding-left: 8px;"
                    type="danger"
                    @click="checkApplyFailReason">
                  查看审核意见
                </el-button>
              </div>
            </td>
          </tr>

          <tr style="display: flex; justify-content: flex-start; align-items: center;">
            <td>
              <el-tag :type="(applyFileState === 2 || meetingData.isApplyMaterials === 0) ? 'success' : ''"
                      style="width: 65px; height: 65px; border-radius: 50%; box-shadow: 1px 1px 5px #000;">
                <div
                    style="font-size: 14px; text-align: center; display: flex; flex-direction: column; align-items: center; padding-top: 8px;">
                  <div>2</div>
                  <div style="font-size: 10px; margin-top: -10px;">报名材料</div>
                </div>
                <i class="el-icon-bottom" style="margin-left: 5%; font-size: 40px; margin-top: 10%;"></i>
              </el-tag>
            </td>
            <td v-if="meetingData && meetingData.isApplyMaterials !== 0"
                style="display: flex; justify-content: center; align-items: center; margin-top: -50px;">
              <el-upload
                  :action="uploadAction"
                  :before-upload="beforeUpload"
                  :disabled="isMaterialUploadDisabled || !isApplyPassed"
                  :headers="uploadHeaders"
                  :on-error="handleMaterialError"
                  :on-success="handleMaterialSuccess"
                  :show-file-list="false"
                  :type="getMaterialButtonType">
                <el-button
                    :disabled="isMaterialUploadDisabled"
                    :plain="!(applyFileState === 1 || applyFileState === 2)"
                    :type="getMaterialButtonType" icon="el-icon-circle-check"
                    size="mini"
                    style="width: 110px; justify-content: flex-start;padding-left: 8px;">
                  {{
                    (applyFileState === 1 || applyFileState === 2) ? (applyFileState === 1 ? '审核中' : '材料已上传') : '上传报名资料'
                  }}
                </el-button>
              </el-upload>
              <el-button v-if="applyFileState ===3 " icon="el-icon-circle-check"
                         plain size="mini"
                         style="width: 110px;justify-content: flex-start;padding-left: 8px;" type="danger" @click="checkApplyFileFailReason">查看审核意见
              </el-button>
            </td>
          </tr>

          <tr style="display: flex; justify-content: flex-start; align-items: center;">
            <td>
              <el-tag style="width: 65px; height: 65px; border-radius: 50%; box-shadow: 1px 1px 5px #000;">
                <div
                    style="text-align: center; font-size: 16px; display: flex; flex-direction: column; padding-top: 8px;">
                  <div>3</div>
                  <div style="font-size: 12px; margin-top: -10px;">等待开拍</div>
                </div>
              </el-tag>
            </td>
          </tr>
        </table>
      </el-col>
    </div>
    <div v-else>
      <div class="auctioneer-info-div">
        <img :src="imgLink" class="auctioneer-img-class">
        <div class="auctioneer-info-detail">
          <span class="auctioneer-info-span show-ellipsis">拍卖师：<span
              :title="auctioneerData.name">{{ auctioneerData.name }}</span> </span><br>
          <span class="auctioneer-info-span show-ellipsis">拍卖师证号：<span
              :title="auctioneerData.idNumber">{{ auctioneerData.idNumber }}</span> </span>
        </div>
      </div>
      <div class="message-box-div">
        <ul v-if="hallMessageData.length>0" id="messageBox" class="send_msg_list" style="height: 120px;">
          <li v-for="m in hallMessageData" :key="m.id" :class="m.msgType==3?'stype3':(m.msgType==2?'stype1':'stype2')">
            <p class="speaktit lineh16">
              <span :style="m.msgType==3?'color: rgba(214, 54, 59, 1);':''" class="system-info-type">
                {{ m.msgType == 3 ? '系统消息' : (m.msgType == 2 ? '拍卖会' : '标的') }}
              </span>
              <span class="system-info-time">{{ m.createTime }}</span>
            </p>
            <p class="speak-txt-class">{{ m.content }}</p>
          </li>
        </ul>
        <div v-else class="no-message-div">暂无竞价消息</div>
      </div>
      <div style="height: 215px;">
        <el-table
            :data="priceDataList"
            :row-class-name="tableRowClassName"
            style="width: 99% ;height: 100%; overflow-y: scroll;">
          <el-table-column align="center" label="状态" show-overflow-tooltip width="60px">
            <template slot-scope="scope">
              <span
                  :class="{
                    'leading-status': isLeadingOrDealStatus(scope.row),
                    'back-status': scope.row.priceState === -1,
                    'out-status': !isLeadingOrDealStatus(scope.row) && scope.row.priceState !== -1,
                  }"
                  class="tab-content">
                {{
                  (parseFloat(scope.row.quoted).toFixed(2) == parseFloat(outLotData.currentQuoted).toFixed(2) && scope.row.priceState == 1) ?
                      (outLotData.auctionStatus == 3 ? '成交' : '领先') :
                      (scope.row.priceState == -1 ? '回退' : '出局')
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="竞买号牌" prop="bidCode" show-overflow-tooltip
                           width="78px"></el-table-column>
          <el-table-column align="center" label="竞拍价" prop="content" show-overflow-tooltip width="150px">
            <template slot-scope="scope">
              <span :class="{'leading-price': isLeadingOrDealStatus(scope.row)}" class="tab-content">
                ￥{{ parseFloat(scope.row.quoted).toFixed(2) }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog
        :before-close="handleClose"
        :visible.sync="dialogVisible"
        title="报名材料审核意见"
        width="50%">
      <div v-if="applyFileFailReason" style="white-space: pre-line;">
        {{ applyFileFailReason }}
      </div>
      <div v-else>
        暂无审核意见
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
        :before-close="handleClose"
        :visible.sync="applyDialogVisible"
        title="缴纳保证金审核意见"
        width="50%">
      <div v-if="applyFailReason" style="white-space: pre-line;">
        {{ applyFailReason }}
      </div>
      <div v-else>
        暂无审核意见
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="applyDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {priceList} from '@/api/biz/auction/lotQuoted';
import {hallMessage} from '@/api/biz/auction/auctionMessage';
import {mapGetters} from "vuex";
import {cmsGetApplyState, getBidCode, updateApplyFile} from "@/api/biz/auction/lotApply";
import {getToken} from "@/util/auth";
import {getMeetingDetail} from '@/api/biz/auction/auctionMeeting';

export default {
  name: "lotTalKView",
  props: ['outLotId', 'meetingId', 'outLotData', 'auctioneerData', 'meetingData',],
  data() {
    return {
      dialogVisible: false,
      applyDialogVisible: false,
      applyFileFailReason: '',
      applyFailReason: '',
      uploadedFileInfo: null,
      applyState: 0,
      applyFileState: 0,
      isMaterialUploaded: false,
      isAuctionStartedNow: false,
      isAuctionStarted: false,
      timerInterval: null,
      bidCode: 0,
      messageType: 1,
      messageContent: '',
      priceDataList: [],
      page: {
        pageSize: 1000,
        currentPage: 1,
        total: 0
      },
      hallMessageData: [],
      website: {
        tokenHeader: 'Authorization'
      }
    };
  },
  computed: {
    token() {
      return getToken();
    },
    isApplyPassed() {
      return this.applyState === 2;
    },
    getMaterialButtonType() {
      if (!this.isApplyPassed) {
        return 'info';
      } else if (this.applyFileState === 2) {
        return 'success';
      } else if (this.applyFileState === 1) {
        return 'warning';
      } else if (this.applyFileState === 3) {
        return 'danger';
      } else if (this.applyFileState === 2 || this.applyFileState === 0) {
        return 'primary';
      } else {
        return 'primary';
      }
    },
    applyStatusText() {
      switch (this.applyState) {
        case 0:
          return '报名';
        case 1:
          return '审核中';
        case 2:
          return '已报名';
        case 3:
          return '审核未通过';
        default:
          return '报名';
      }
    },
    applyStatusType() {
      switch (this.applyState) {
        case 0:
          return 'danger';
        case 1:
          return 'warning';
        case 2:
          return 'success';
        case 3:
          return 'danger';
        default:
          return 'info';
      }
    },
    getMaterialButtonText() {
      switch (this.applyFileState) {
        case 0:
          return '上传报名资料';
        case 1:
          return '审核中';
        case 2:
          return '材料已上传';
        case 3:
          return '重新上传';
        default:
          return '上传报名资料';
      }
    },
    isLogin() {
      return this.userInfo.user_name ? 1 : 0;
    },
    executeTime() {
      return new Date(new Date(this.outLotData.executeTime).getTime() + 1000 * this.outLotData.timeRemaining);
    },
    ...mapGetters(["userInfo"]),
    imgLink() {
      if (this.auctioneerData && this.auctioneerData.attachList)
        return this.auctioneerData.attachList[0].link;
      return null;
    },
    uploadAction() {
      return `/api/sino-resource/oss/endpoint/put-file?${this.website.tokenHeader}=${getToken()}`;
    },
    uploadHeaders() {
      return {
        'Authorization': 'Basic c2lubzpzaW5vX3NlY3JldA==',
        'Sino-Auth': this.token || ''
      };
    },
    isMaterialUploadDisabled() {
      return !this.isApplyPassed || this.applyFileState === 1 || this.applyFileState === 2;
    },
    isApplyTimeValid() {
      if (!this.meetingData || !this.meetingData.applyEndTime) {
        return true; // 如果没有截止时间，默认允许报名
      }

      const applyEndTime = new Date(this.meetingData.applyEndTime).getTime();
      const currentTime = new Date().getTime();

      return currentTime <= applyEndTime;
    },
  },
  methods: {
    // 修改关键方法：判断是否是领先或成交状态（都显示红色）
    isLeadingOrDealStatus(row) {
      // 如果是领先状态（当前报价等于标的当前报价且状态为1）
      const isLeading = parseFloat(row.quoted).toFixed(2) == parseFloat(this.outLotData.currentQuoted).toFixed(2) &&
          row.priceState == 1;

      // 如果是成交状态（标的已成交且当前行报价等于成交价）
      const isDeal = this.outLotData.auctionStatus == 3 &&
          parseFloat(row.quoted).toFixed(2) == parseFloat(this.outLotData.currentQuoted).toFixed(2);

      return isLeading || isDeal;
    },

    tableRowClassName({row}) {
      if (this.isLeadingOrDealStatus(row)) {
        return 'leading-row';
      }
      return '';
    },

    toApply() {
      if (this.isLogin) {
        if (this.userInfo.companyId == null || this.userInfo.isAuth == 0) {
          return this.$message({type: 'warning', message: '请完成实名认证审核'})
        }
        let routeQuery = {
          lotId: this.outLotId,
          meetingId: this.outLotData.meetingId
        };

        if (this.applyState === 3) {
          routeQuery.reApply = 'true';
        }
        this.$router.push({
          path: "/toApply",
          query: routeQuery
        });
      } else {
        sessionStorage.setItem('activeLotId', this.outLotId);
        this.$router.push("/login");
      }
    },

    getApplyState() {
      if (this.isLogin) {
        cmsGetApplyState({lotId: this.outLotId, bidderId: this.userInfo.user_id}).then(res => {
          this.applyState = res.data.data.applyState;
          this.applyFileState = res.data.data.applyFileState;
          this.applyFileFailReason = res.data.data.applyFileFailReason;
          this.applyFailReason = res.data.data.applyFailReason;
          this.canQuote = res.data.data.canQuote;
          this.cannotQuoteReason = res.data.data.cannotQuoteReason;

          if (this.applyFileState === 1 || this.applyFileState === 2) {
            this.isMaterialUploaded = true;
          } else if (this.applyFileState === 3) {
            this.isMaterialUploaded = false;
          }
          if (this.meetingData && this.meetingData.id && this.applyState !== 0) {
            getBidCode({meetingId: this.meetingData.id, bidderId: this.userInfo.user_id}).then(res => {
              if (res && res.data && res.data.data) {
                this.bidCode = res.data.data.bidCode;
              }
            })
          }
        })


      } else {
        this.applyState = 0;
        this.applyFileState = 0;
      }
    },

    checkApplyFileFailReason() {
      this.dialogVisible = true;
    },

    checkApplyFailReason() {
      this.applyDialogVisible = true;
    },

    handleClose(done) {
      this.$confirm('确认关闭？')
          .then(() => {
            done();
          })
          .catch(() => {
          });
    },

    handleMaterialSuccess(response) {
      if (this.applyFileState === 3) {
        this.isMaterialUploaded = false;
      } else if (this.applyFileState === 1 || this.applyFileState === 2) {
        this.$message.info('报名材料已上传，无需重复上传');
        return;
      }
      this.isMaterialUploaded = true;
      this.applyFileState = 1;
      this.uploadedFileInfo = response.data;
      this.$message.success('材料上传成功');
      this.submitApplyWithFile()
    },

    downloadBiddingRules() {
      if (!this.isApplyPassed) {
        this.$message.warning('请先通过报名审核');
        return;
      }

      getMeetingDetail(this.meetingId).then(res => {
        if (res.data.code === 200 && res.data.data) {
          const materialsName = res.data.data.materialsName;
          if (materialsName) {
            const link = document.createElement('a');
            link.href = materialsName;
            link.download = '';
            link.target = '_blank';
            link.click();
          } else {
            this.$message.warning('未找到竞价规则文件');
          }
        } else {
          this.$message.error('获取竞价规则失败: ' + (res.data.message || '未知错误'));
        }
      }).catch(err => {
        console.error('获取竞价规则异常:', err);
        this.$message.error('获取竞价规则异常');
      });
    },

    submitApplyWithFile() {
      if (!this.uploadedFileInfo) {
        this.$message.warning('未获取到上传文件信息');
        return;
      }
      const applyParams = {
        meetingId: this.outLotData.meetingId,
        bidderId: this.userInfo.user_id,
        applyFile: this.uploadedFileInfo.link,
        applyFileState: 1
      };
      updateApplyFile(applyParams)
          .then(res => {
            if (res.data.code === 200) {
              this.$message.success('申请材料提交成功');
            } else {
              this.$message.error('申请材料提交失败: ' + res.data.message);
            }
          })
          .catch(err => {
            console.error('申请材料提交异常:', err);
            this.$message.error('申请材料提交异常');
          });
    },

    handleMaterialError(err, file, fileList) {
      console.error('上传失败', err, file, fileList);
      this.$message.error('材料上传失败');
      if (this.applyFileState === 1) {
        this.applyFileState = 0;
        this.isMaterialUploaded = false;
      }
    },

    beforeUpload(file) {
      if (this.applyFileState === 2) {
        this.$message.info('报名材料已审核通过，无需重复上传');
        return false;
      }

      if (this.applyFileState === 1) {
        this.$message.info('报名材料正在审核中，请耐心等待');
        return false;
      }

      const isPdf = file.type === 'application/pdf' || file.name.endsWith('.pdf');
      if (!isPdf) {
        this.$message.error('只能上传PDF格式文件!');
        return false;
      }

      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error('上传文件大小不能超过 50MB!');
      }
      return isLt50M;
    },

    initAuctionTimer() {
      const checkTime = () => {
        const meetingData = this.meetingData;
        if (!meetingData || !meetingData.startAuctionTime) {
          this.isAuctionStarted = true;
          return;
        }
        const startTime = new Date(meetingData.startAuctionTime).getTime();
        const now = Date.now();
        this.isAuctionStarted = now < startTime - 10 * 60 * 1000;
      };
      checkTime();
      this.timerInterval = setInterval(checkTime, 1000);
    },

    changeMessageType(type) {
      this.messageType = type;
    },

    flushCurrentlotData() {
      this.getPriceList();
      this.getMessageList();
    },

    getPriceList() {
      let page = this.page;
      priceList(page.currentPage, page.pageSize, {lotId: this.outLotId}).then(res => {
        this.priceDataList = res.data.data.records;
        this.page.total = res.data.data.total;
      })
    },

    getMessageList() {
      let param = {
        meetingId: this.meetingId,
        lotId: this.outLotId,
      }
      hallMessage(param).then(res => {
        this.hallMessageData = res.data.data;
        if (this.hallMessageData.length > 0) {
          this.$nextTick(() => {
            const msgBox = document.getElementById('messageBox');
            if (msgBox) {
              msgBox.scrollTop = msgBox.scrollHeight;
            }
          })
        }
      })
    }
  },
  watch: {
    outLotId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.flushCurrentlotData();
        if (this.isLogin) {
          this.getApplyState();
        }
      }
    },
    meetingData: {
      handler(newVal) {
        if (newVal && newVal.id && this.outLotId) {
          if (this.isLogin) {
            this.getApplyState();
          }
        }
      },
      immediate: false
    }
  },
  created() {
    this.flushCurrentlotData();
    if (this.isLogin) {
      this.getApplyState();
    }
    this.initAuctionTimer();
  },
  beforeDestroy() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }
}
</script>

<style scoped>
.auction-process-div {
  padding: 10px 0;
}

.flowChartTable1 td {
  padding: 0px 15px;
}

.no-message-div {
  margin-left: 10px;
  height: 50px;
  opacity: 1;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 50px;
  color: rgba(102, 102, 102, 1);
}

.price-type-value {
  display: inline-block;
  width: 40px;
  height: 20px;
  opacity: 1;
  border-radius: 2px;
  background: rgba(225, 243, 216, 1);
  font-size: 13px;
  font-weight: 500;
  line-height: 18.82px;
  color: rgba(30, 169, 106, 1);
  text-align: center;
}

.price-item-div {
  width: 90px;
  text-align: center;
  display: inline-block;
}

.price-list-value {
  height: 24px;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 20.27px;
  color: rgba(102, 102, 102, 1);
}

.price-list-label {
  display: inline-block;
  height: 40px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 40px;
  color: rgba(51, 51, 51, 1);
}

.price-list-div {
  height: 80px;
}

.speak-txt-class {
  padding: 10px;
  width: 210px;
  opacity: 1;
  border-radius: 5px;
  background: rgba(243, 245, 247, 1);
  font-size: 13px;
  font-weight: 400;
  line-height: 18.82px;
  color: rgba(0, 0, 0, 1);
}

.system-info-time {
  margin-left: 8px;
  display: inline-block;
  height: 21px;
  opacity: 1;
  font-size: 14px;
  font-weight: 400;
  line-height: 20.27px;
  color: rgba(0, 0, 0, 1);
}

.system-info-type {
  display: inline-block;
  height: 21px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20.27px;
}

.message-box-div {
  overflow: hidden;
  width: 100%;
  margin-left: 3px;
}

.auctioneer-info-detail {
  display: inline-block;
  vertical-align: bottom;
  max-width: 200px;
}

.auctioneer-info-span {
  display: inline-block;
  width: 100%;
  height: 32px;
  opacity: 1;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 32px;
  color: rgba(0, 0, 0, 1);
}

.auctioneer-img-class {
  border-radius: 32px;
  margin-left: 10px;
  width: 64px;
  height: 64px;
  margin-right: 10px;
}

.auctioneer-info-div {
  margin-top: 20px;
  display: flex;
  align-items: center;
  height: 74px;
  overflow: hidden;
}

::v-deep .el-table::before {
  height: 0px;
}

::v-deep .el-table--scrollable-x .el-table__body-wrapper {
  overflow-x: hidden;
}

:deep(.el-table__header-wrapper) {
  position: sticky;
  top: 1px;
  z-index: 10;
}

/* 关键修改：领先和成交都显示红色 */
.leading-status {
  color: #F56C6C !important; /* 红色，同时用于领先和成交 */
  font-weight: bold;
}

.back-status {
  color: #909399 !important; /* 灰色 */
}

.out-status {
  color: #909399 !important; /* 灰色 */
}

/* 价格列样式 */
.leading-price {
  color: #F56C6C !important; /* 红色 */
  font-weight: bold;
}

/* 领先行的单元格样式 */
::v-deep .el-table .leading-row .cell {
  color: #F56C6C !important;
  font-weight: bold;
}
</style>
